import React, { useEffect, useState } from 'react';
import { Avatar, Flexbox, Label } from '../../../../common/fusion-ui';
import { checkNullJson, checkNullStr, getJsonValue, isBoolTrue, isJsonValueTrue, refreshCurrPage } from "../../../../common/fusion-ui/utils/ReactUtils";
import { CssVariant, DefStrNA, Messages } from '../../../../common/fusion-ui/config/FusionConfig';
import { useTheme } from '../../../../common/ProjectThemeProvider';
import { formatDateValue, getAllocatedModuleName, getUserSessionField, printError, printLog, sendRequest } from "../../../utils/AppUtils";
import { useToast } from "../../../../common/fusion-ui/provider/ToastProvider";
import { GenRouteUrls, ModuleFieldsData, ModuleRouteUrls, Modules, ReqUrls } from "../../../config/AppConfig";
import { InvalidPanel, MessageSenderDialog, ThemedButton, ThemedIconButton } from "../../../index";

export const Message_Internal_Panel = React.memo(({
    recordId,
    borderless = true,
    fromPage = false,
    justifyAt = 'start',
}) => {
    const TAG = "Message_Internal_Panel";

    const mf = ModuleFieldsData[Modules.Messages];
    const theme = useTheme();
    const { showToast, changeToastVariant } = useToast();

    const Fields = {
        panelData: 'panelData',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFetched: 'isDataFetched',

        prevRecordId: 'prevRecordId',
        nextRecordId: 'nextRecordId',

        openSendMsgDialog: 'openSendMsgDialog',
        messageDialog_replyMode: 'messageDialog_replyMode',
        messageDialog_replyModeData: 'messageDialog_replyModeData',
        recordMail_submitBtn_AsLoading: 'recordMail_submitBtn_AsLoading',
        recordMail_submitBtn_disabled: 'recordMail_submitBtn_disabled',

        recordMail_replyBtn_Disable: 'recordMail_replyBtn_Disable',
        recordMail_replyBtn_AsLoading: 'recordMail_replyBtn_AsLoading',
    };
    const [fieldsData, setFieldsData] = useState({});
    useEffect(() => {
        // log('useEffect.recordId:', recordId);
        if (checkNullStr(recordId)) fetchPageData(recordId);
    }, [recordId]);

    return (<>
        <div className={'position-relative mt-2 w-100'}>
            <InvalidPanel
                color={theme.text70}
                success={getField(Fields.isDataFound)}
                loading={getField(Fields.isDataLoading)}
                msg={getField(Fields.dataLoadingMsg)}
                show404Image={true}
            />
            {/*header*/}
            <div className={"position-absolute"}
                // Updated by Vandit Tewari (6/11/24) - change the value of top from -1.7 to -2.7 bcz in phones it is overlaping with the avatar of the sender
                style={{ top: isBoolTrue(fromPage) ? '-2.7rem' : '0', right: '-.1rem', zIndex: 10 }}>
                <Flexbox
                    justifyAt={'end'}
                    direction={'row'}
                    overflow={'visible'}>
                    {/* Back to list button*/}
                    {isBoolTrue(fromPage) && <ThemedButton
                        className={'px-2 py-1 text-nowrap fs-sm fw-semi-bold'}
                        m={1}
                        height={'28px'}
                        outlined={true}
                        variant={theme.primaryBlue}
                        text={`Back to ${getAllocatedModuleName(Modules.Messages)}`}
                        href={ModuleRouteUrls[Modules.Messages]} />}

                    {/* prev-button */}
                    <ThemedIconButton
                        className={'p-1 text-nowrap fs-sm fw-semi-bold'}
                        m={1}
                        ml={2}
                        height={'28px'}
                        outlined={true}
                        variant={theme.primaryBlue}
                        disableVariant={'xl'}
                        icon={"bi bi-arrow-left"}
                        tooltip={"Previous"}
                        circular={false}
                        disabled={!checkNullStr(getField(Fields.prevRecordId)) || getField(Fields.isDataLoading)}
                        href={isBoolTrue(fromPage) ? `${GenRouteUrls.msg_internalPage}${getField(Fields.prevRecordId)}` : ''}
                        onClick={() => fetchPageData(getField(Fields.prevRecordId), false)} />

                    {/* next-button */}
                    <ThemedIconButton
                        className={'p-1 text-nowrap fs-sm fw-semi-bold'}
                        m={1}
                        ml={2}
                        height={'28px'}
                        outlined={true}
                        variant={theme.primaryBlue}
                        disableVariant={'xl'}
                        icon={"bi bi-arrow-right"}
                        tooltip={"Next"}
                        circular={false}
                        disabled={!checkNullStr(getField(Fields.nextRecordId)) || getField(Fields.isDataLoading)}
                        href={isBoolTrue(fromPage) ? `${GenRouteUrls.msg_internalPage}${getField(Fields.nextRecordId)}` : ''}
                        onClick={() => fetchPageData(getField(Fields.nextRecordId), false)} />

                    {/*Reply btn*/}
                    {(isRecordReceivedType() && checkNullJson(getField(Fields.panelData))) && <ThemedIconButton
                        className={'p-1 text-nowrap fs-sm fw-semi-bold'}
                        m={1}
                        ml={2}
                        height={'28px'}
                        outlined={true}
                        variant={theme.primaryBlue}
                        disableVariant={'xl'}
                        icon={"bi bi-reply"}
                        tooltip={isFieldTrue(Fields.openSendMsgDialog) ? '' : "Reply"}
                        circular={false}
                        asLoading={isFieldTrue(Fields.recordMail_replyBtn_AsLoading)}
                        disabled={isFieldTrue(Fields.recordMail_replyBtn_Disable) || getField(Fields.isDataLoading)}
                        onClick={() => {
                            fetchRecordReplyModeData(recordId, getField(Fields.panelData));
                        }} />}
                </Flexbox>
            </div>

            {(!isFieldTrue(Fields.isDataLoading) && isFieldTrue(Fields.isDataFound)) &&
                <div className={'w-100 position-relative'}>

                    {/*  Details */}
                    <div>
                        {/*Updated by Vandit Tewari (6/11/24) - add the style elemet as this details are overlaping with the control button at the top so shifted them down*/}
                        <div className={'w-100'} style={{ marginTop: '5vh' }}>
                            <div className={''}>
                                <Avatar
                                    wrapperClassName={''}
                                    imgClassName={'rounded-4'}
                                    circular={false}
                                    size={'90px'}
                                    justifyAt={justifyAt}
                                    // height={'106px'}
                                    bordered={false}
                                    showFullPreviewDialog={true}
                                    showInitials={true}
                                    nameForInitials={getPanelField(mf.fromName)}>
                                    {getPanelField(mf.fromImage)}
                                </Avatar>
                            </div>

                            <Label className="fs-lg" widthClass={'100'}
                                color={theme.text}
                                textAt={justifyAt}>
                                <span className={'fw-bold fs-normalx'} style={{ color: theme.text50 }}>{mf.fromName.title}: </span>
                                <span className={'fw-semi-bold'}>{getPanelField(mf.fromName, DefStrNA)}</span>
                            </Label>
                        </div>
                        <div className="ms-3x mt-1" style={{}}>
                            <table className={'w-100x'} style={{ color: theme.text }}>
                                <tbody>
                                    {/* Updated by Vandit Tewari on (8/11/24) - in every tr given a class 'wmInternalPageTrBreak' done this bcz below 560px the text in some td getting out of screen as these both comes in same row - declared in fusion css also in all td added class text-break*/}
                                    {/* toName */}
                                    <tr className='wmInternalPageTrBreak'>
                                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start fw-bold'}>{mf.toName.title}:</th>
                                        <td className={'px-2 text-wrap text-block fw-semi-bold text-break'}>{getPanelField(mf.toName, DefStrNA)}</td>
                                    </tr>

                                    {/* subject */}
                                    <tr className='wmInternalPageTrBreak'>
                                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start fw-bold'}>{mf.subject.title}:</th>
                                        <td className={'px-2 text-wrap text-block fw-semi-bold text-break'}>{getPanelField(mf.subject, DefStrNA)}</td>
                                    </tr>

                                    {/* insertDate */}
                                    <tr className='wmInternalPageTrBreak'>
                                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start fw-bold'}>{mf.insertDate.title}:</th>
                                        <td className={'px-2 text-wrap text-break'}>{formatDateValue(getPanelField(mf.insertDate), DefStrNA)}</td>
                                    </tr>

                                    {/* body */}
                                    <tr className='wmInternalPageTrBreak'>
                                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start fw-bold w-100'}>Message:</th>
                                        <td className={'px-2 text-wrap text-block w-100 text-break'}>
                                            {/*{getPanelField(mf.body, DefStrNA)}*/}
                                            <div className={'m-0 p-0 text-block w-100 text-wrap'}
                                                style={{ color: theme.text }}
                                                dangerouslySetInnerHTML={{ __html: getPanelField(mf.body, DefStrNA) }} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            {/*controls*/}
                        </div>
                    </div>
                </div>}
        </div>
        {createSendMessageDialog()}
    </>)

    function createSendMessageDialog() {
        return <MessageSenderDialog
            open={isFieldTrue(Fields.openSendMsgDialog)}
            recordId={getField(Fields.currRecordId)}
            replyMode={isFieldTrue(Fields.messageDialog_replyMode)}
            replyData={getField(Fields.messageDialog_replyModeData, {})}
            recipientNameAsEmail={false}
            asDrawer={isBoolTrue(fromPage)}
            disableSubmit={isFieldTrue(Fields.recordMail_submitBtn_disabled)}
            loadingSubmit={isFieldTrue(Fields.recordMail_submitBtn_AsLoading)}
            onSubmit={handleReplyMsgSubmit}
            onHide={handleClose}
            onCancel={handleClose}
        />

        function handleClose() {
            updateField(Fields.openSendMsgDialog, false);
            updateField(Fields.currRecordId, null);
            updateField(Fields.messageDialog_replyMode, false);
            updateField(Fields.recordMail_submitBtn_disabled, false);
            updateField(Fields.recordMail_submitBtn_AsLoading, false);
            updateField(Fields.messageDialog_replyModeData, {});
        }
    }

    async function fetchPageData(recordId, checkBefore = true) {
        const fun = 'fetchPageData:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isDataFetched))) {
            log(fun, 'recordId:', recordId);
            updateField(Fields.isDataFetched, true);
            updateField(Fields.recordId, recordId);
            if (checkNullStr(recordId)) {
                updateField(Fields.panelData, {});
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, true);
                updateField(Fields.dataLoadingMsg, "");
                updateField(Fields.nextRecordId, null);
                updateField(Fields.prevRecordId, null);

                //send-request
                const REQUEST_OPTIONS = {
                    recordId: recordId,
                    getAdjacentRecordIds: true,
                    fromInternalPage: true,
                };
                try {
                    sendRequest({
                        reqUrl: ReqUrls.msg__internalPage_fetchData,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const panelData = getJsonValue(fetchedData, 'data', {});
                            const success = isJsonValueTrue(fetchedData, 'success');
                            const message = getJsonValue(fetchedData, 'message');

                            if (success) {
                                // toast(message, CssVariant.success)
                                updateField(Fields.panelData, panelData);
                                updateField(Fields.nextRecordId, getJsonValue(panelData, 'nextRecordId'));
                                updateField(Fields.prevRecordId, getJsonValue(panelData, 'prevRecordId'));
                                updateField(Fields.isDataFound, success);
                                updateField(Fields.isDataLoading, false);
                            } else {
                                toast(message, CssVariant.danger)
                                updateField(Fields.dataLoadingMsg, message);
                                updateField(Fields.isDataLoading, false);
                                updateField(Fields.isDataFound, false);
                            }
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            toast(Messages.fetchError, CssVariant.danger)
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } catch (error) {
                    toast(Messages.fetchError, CssVariant.danger)
                    logErr(fun, error);
                    updateField(Fields.dataLoadingMsg, Messages.fetchError);
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            } else {
                toast('Record-id not found!', CssVariant.danger);
                updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, false);
            }
        }
    }

    async function fetchRecordReplyModeData(recordId, recordItem) {
        const fun = 'fetchRecordReplyModeData:';
        const fromId = getJsonValue(recordItem, mf.fromId.column);
        log(fun, 'recordId:', recordId, 'fromId:', fromId);
        if (checkNullStr(recordId)) {
            updateField(Fields.messageDialog_replyModeData, {});
            updateField(Fields.recordMail_replyBtn_AsLoading, true);
            updateField(Fields.recordMail_replyBtn_Disable, true);

            //send-request
            const REQUEST_OPTIONS = {
                recordId: recordId,
                fromId: fromId,
                fetchThread: true,
                fetchImages: false,
            };
            try {
                sendRequest({
                    reqUrl: ReqUrls.msg__internalPage_fetchData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const panelData = getJsonValue(fetchedData, 'data', {});
                        const success = isJsonValueTrue(fetchedData, 'success');
                        const message = getJsonValue(fetchedData, 'message');

                        if (success) {
                            updateField(Fields.messageDialog_replyModeData, panelData);
                            updateField(Fields.messageDialog_replyMode, true);
                            updateField(Fields.openSendMsgDialog, true);
                        } else {
                            toast(message, CssVariant.danger)
                            toast("Invalid record id!", CssVariant.danger);
                        }

                        updateField(Fields.recordMail_replyBtn_AsLoading, false);
                        updateField(Fields.recordMail_replyBtn_Disable, false);
                    }),
                    onError: ((error) => {
                        logErr(fun, error);
                        toast("Reply failed, please try again!", CssVariant.danger);
                        updateField(Fields.recordMail_replyBtn_AsLoading, false);
                        updateField(Fields.recordMail_replyBtn_Disable, false);
                    }),
                });
            } catch (error) {
                logErr(fun, error);
                toast("Reply failed, please try again!", CssVariant.danger);
                updateField(Fields.recordMail_replyBtn_AsLoading, false);
                updateField(Fields.recordMail_replyBtn_Disable, false);
            }
        } else {
            toast('Record-id not found!', CssVariant.danger);
        }
    }

    function handleReplyMsgSubmit(formData, recordId) {
        const fun = 'handleReplyMsgSubmit:';
        log(fun, 'formData:', formData, 'recordId:', recordId);
        if (checkNullStr(recordId)) {
            try {
                // const allFieldsChecked = false;
                const allFieldsChecked = true;
                if (allFieldsChecked) {
                    updateField(Fields.recordMail_submitBtn_AsLoading, true);
                    updateField(Fields.recordMail_submitBtn_disabled, true);

                    const REQUEST_OPTIONS = {
                        recordId: recordId,
                        replyMode: isFieldTrue(Fields.messageDialog_replyMode),
                        formData: formData,
                    };
                    sendRequest({
                        reqUrl: ReqUrls.msg__mainPage_createMsg,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const message = getJsonValue(fetchedData, 'message');
                            const success = isJsonValueTrue(fetchedData, 'success');

                            if (success) {
                                toast(message, CssVariant.success);
                                updateField(Fields.openSendMsgDialog, false);
                                if (isFieldTrue(Fields.messageDialog_replyMode)) {
                                    updateField(Fields.messageDialog_replyMode, false);
                                } else {
                                    refreshCurrPage();
                                }
                            } else {
                                toast(message, CssVariant.danger);
                            }
                            updateField(Fields.recordMail_submitBtn_disabled, false);
                            updateField(Fields.recordMail_submitBtn_AsLoading, false);
                        }),
                        onError: ((error) => {
                            toast("Couldn't send message, please try again!");
                            updateField(Fields.recordMail_submitBtn_AsLoading, false);
                            updateField(Fields.recordMail_submitBtn_disabled, false);
                            logErr(fun, error);
                        }),
                    });
                }
            } catch (error) {
                toast("Couldn't send message, please try again!");
                updateField(Fields.recordMail_submitBtn_AsLoading, false);
                updateField(Fields.recordMail_submitBtn_disabled, false);
                logErr(fun, error);
            }
        } else {
            toast('Record-id not found!', CssVariant.danger);
        }
    }

    //======================Util Functions start=====================

    function getPanelField(colField, defValue) {
        return getJsonValue(getField(Fields.panelData), colField.column, defValue);
        // return getJsonValue(getField(Fields.panelData), colField, defValue);
    }

    function isRecordReceivedType() {
        //	If msg.message_from == session.memberId, it's "sent"
        return !(getPanelField(mf.fromId) == getUserSessionField('memberId'));
    }


    function updateField(field, value) {
        setFieldsData(prevState => ({ ...prevState, [field]: value }));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default Message_Internal_Panel;
